import React from 'react';
import {
    ArrayField,
    Datagrid,
    DateField,
    Filter,
    List,
    SelectInput,
    Show,
    SimpleShowLayout,
    TextField,
    TextInput,
} from 'react-admin';
import { BulkDeleteButtonDisable, CustomPagination, isGeEmployee } from './utils';
import { CardActions } from '@material-ui/core';
import CancelTransactionButton from './transactionButton/CancelTransactionButton';

const TransactionsPaymeActions = ({ data, permissions }) => (
    <CardActions
        submitOnEnter={false}
        style={{ zIndex: 2, display: 'inline-block', float: 'right' }}
    >
        {isGeEmployee(permissions) && (
            <CancelTransactionButton
                record={data}
                transaction_type={'payme'}
            />
        )}
    </CardActions>
);

const TransactionsPaymeFilter = props => (
    <Filter {...props}>
        <SelectInput
            label="Поле"
            source="field"
            choices={[
                { id: 'id', name: 'Id' },
                { id: 'external_id', name: 'Id в Payme' },
                { id: 'order_id', name: 'Id заказа' },
                { id: 'profile_payment_method_id', name: 'Id метода оплаты' },
                { id: 'amount', name: 'Сумма транзакции' },
                { id: 'currency', name: 'Валюта транзакции' },
                { id: 'email', name: 'Почта' },
                { id: 'description', name: 'Описание' },
                { id: 'status_semantic', name: 'Статус' },
                { id: 'error_code', name: 'Код ошибки' },
                { id: 'external_created', name: 'Дата и время создания' },
                { id: 'external_auth', name: 'Дата и время авторизации' },
                { id: 'external_paid', name: 'Дата и время оплаты' },
                { id: 'external_canceled', name: 'Дата и время отмены' },
                { id: 'created', name: 'Время создания' },
                { id: 'updated', name: 'Последнее обновление' },
            ]}
            alwaysOn
        />
        <TextInput
            label="Поиск"
            source="q"
            alwaysOn
        />
    </Filter>
);

export const TransactionsPaymeList = props => (
    <List
        {...props}
        filters={<TransactionsPaymeFilter />}
        bulkActionButtons={<BulkDeleteButtonDisable />}
        pagination={<CustomPagination />}
    >
        <Datagrid rowClick="show">
            <TextField
                label="Id"
                source="id"
            />
            <TextField
                label="Id в Payme"
                source="external_id"
            />
            <TextField
                label="Id заказа"
                source="order_id"
            />
            <TextField
                label="Id метода оплаты"
                source="profile_payment_method_id"
            />
            <TextField
                label="Сумма транзакции"
                source="amount"
            />
            <TextField
                label="Оставшаяся сумма захвата"
                source="amount_capturable"
            />
            <TextField
                label="Валюта транзакции"
                source="currency"
            />
            <TextField
                label="Почта"
                source="email"
            />
            <TextField
                label="Описание"
                source="description"
            />
            <TextField
                label="Статус"
                source="status_semantic"
            />
            <TextField
                label="Код ошибки"
                source="error_code"
            />
            <DateField
                label="Дата и время создания"
                source="external_created"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Дата и время авторизации"
                source="external_auth"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Дата и время платежа"
                source="external_paid"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Дата и время отмены"
                source="external_canceled"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Время создания"
                source="created"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Последнее обновление"
                source="updated"
                showTime
                locales="ru-RU"
            />
        </Datagrid>
    </List>
);

export const TransactionsPaymeShow = ({ permissions, ...props }) => (
    <Show
        {...props}
        actions={<TransactionsPaymeActions permissions={permissions} />}
    >
        <SimpleShowLayout>
            <TextField
                label="Id"
                source="id"
            />
            <TextField
                label="Id в Payme"
                source="external_id"
            />
            <TextField
                label="Id заказа"
                source="order_id"
            />
            <TextField
                label="Id метода оплаты"
                source="profile_payment_method_id"
            />
            <TextField
                label="Сумма транзакции"
                source="amount"
            />
            <TextField
                label="Оставшаяся сумма захвата"
                source="amount_capturable"
            />
            <TextField
                label="Валюта транзакции"
                source="currency"
            />
            <TextField
                label="Почта"
                source="email"
            />
            <TextField
                label="Описание"
                source="description"
            />
            <TextField
                label="Статус"
                source="status_semantic"
            />
            <TextField
                label="Код статуса"
                source="status"
            />
            <TextField
                label="Код ошибки"
                source="error_code"
            />
            <DateField
                label="Дата и время создания"
                source="external_created"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Дата и время авторизации"
                source="external_auth"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Дата и время платежа"
                source="external_paid"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Дата и время отмены"
                source="external_canceled"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Время создания"
                source="created"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Последнее обновление"
                source="updated"
                showTime
                locales="ru-RU"
            />
            <ArrayField
                label="История статусов"
                source="status_history"
            >
                <Datagrid>
                    <TextField
                        label="Статус"
                        source="status_semantic"
                    />
                    <TextField
                        label="Код статуса"
                        source="status"
                    />
                    <TextField
                        label="Код ошибки"
                        source="code"
                    />
                    <TextField
                        label="Причина отказа"
                        source="decline_code"
                    />
                    <TextField
                        label="Время создания в Payme"
                        source="remote_created"
                    />
                    <TextField
                        label="Локальное время создания"
                        source="created"
                    />
                </Datagrid>
            </ArrayField>
        </SimpleShowLayout>
    </Show>
);
